import { render, staticRenderFns } from "./UserArtworks.vue?vue&type=template&id=363e3f91"
import script from "./UserArtworks.vue?vue&type=script&lang=js"
export * from "./UserArtworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports